import React from "react";
import { useLocation } from "react-router";
import { observer } from "mobx-react-lite";

import {
  IonAvatar,
  IonButton,
  IonItem,
  IonLabel,
  IonIcon,
  IonSkeletonText,
} from "@ionic/react";

import { personCircle } from "ionicons/icons";

import { StandardResponse } from "../../../models/StandardResponses";

interface StandardResponsesListItemProps {
  standardResponse: StandardResponse;
  onSelectItem: (item: StandardResponse) => void;
}

const StandardResponsesListItem: React.FC<StandardResponsesListItemProps> =
  observer(({ standardResponse, onSelectItem }) => {
    const location = useLocation();

    if (standardResponse && standardResponse.loaded) {
      return (
        <IonItem
          onClick={() => onSelectItem(standardResponse)}
          detail={false}
          button
        >
          <IonLabel>
            <h2>{standardResponse.name}</h2>
          </IonLabel>
        </IonItem>
      );
    }

    return (
      <IonItem>
        <IonAvatar
          slot="start"
          style={{
            height: "50px",
            width: "50px",
          }}
        >
          <IonIcon
            icon={personCircle}
            color="medium"
            style={{ fontSize: "50px" }}
          ></IonIcon>
        </IonAvatar>
        <IonLabel>
          <h2>
            <IonSkeletonText animated style={{ width: "70%" }} slot="start" />
          </h2>
        </IonLabel>
      </IonItem>
    );
  });

export default StandardResponsesListItem;
